<!-- begin:: Content Head -->
<ng-container *ngIf="(headerTranslateKey$ | async) as headerTranslateKey; else noSubheader">
	<div class="kt-subheader kt-grid__item" [ngClass]="{'kt-container--clear': clear}" id="kt_subheader">
		<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
			<div class="kt-subheader__main">
				<h3 class="kt-subheader__title">{{ headerTranslateKey | translate }}</h3>
				<!-- <h4 *ngIf="descriptionTranslateKey$ | async descriptionTranslateKey" class="kt-subheader__desc">{{ descriptionTranslateKey | translate }}</h4> -->
				<!-- <div class="kt-subheader__breadcrumbs" *ngIf="breadcrumbs$ | async as breadcrumbs">
					<a class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></a>
					<ng-container *ngFor="let breadcrumb of breadcrumbs">
						<span class="kt-subheader__breadcrumbs-separator"></span>
						<a [routerLink]="breadcrumb.url" class="kt-subheader__breadcrumbs-link">
							{{ breadcrumb.title | translate }}
						</a>
					</ng-container>
				</div> -->
			</div>
		</div>
	</div>
	<!-- end:: Content Head -->
</ng-container>

<ng-template #noSubheader>
	<div class="kt-subheader kt-grid__item no-subheader" id="kt_subheader"></div>
</ng-template>